import React from "react";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import SEO from "../components/shared/SEO";
import TripSuggestionsHero from "../components/trip-suggestions/TripSuggestionsHero";
import TripSuggestionsGrid from "../components/trip-suggestions/TripSuggestionsGrid";

export default function TripSuggestions() {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-white pt-16">
      <SEO
        title="Trip Suggestions | SoloConnect"
        description="Discover handpicked trip ideas and trending destinations for solo travelers on SoloConnect."
        keywords="trip suggestions, travel ideas, destinations, solo travel, SoloConnect"
      />
      <Newnabar />

      <main className="flex-grow">
        <TripSuggestionsHero />
        <TripSuggestionsGrid />
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
